import { useMutation } from 'react-query';
import { authFetchBlob } from '../../CommonUtils/authFetchBlob';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { ProviderType } from '../DocumentVault.meta';

interface DownloadFileParams {
  clientId: string;
  path: string;
  externalFileId?: string | null;
  providerType: ProviderType;
}

const downloadFile = ({ clientId, path, externalFileId, providerType }: DownloadFileParams) => {
  return authFetchBlob(
    urlWithParams(
      '/Consumer/DocumentVault/DownloadFile',
      {
        clientId,
        filePath: path,
        externalFileId,
        providerType,
      },
      { skipNulls: true },
    ),
  );
};

export const useDownloadFileMutation = () => {
  return useMutation(downloadFile);
};
